export default __webpack_public_path__ + "static/matrix-partners-d2eb435a980c61072ff4b04963b72f19.svg";